import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import { Paper, makeStyles } from "@material-ui/core";

import InternalChatHeader from "../InternalChatHeader";
import InternalMessagesList from "../InternalMessagesList";
import InternalMessageInput from "../InternalMessageInput";
import connectToSocket from "../../services/socket-io";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    position: "relative",
    overflow: "hidden",
  },
  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: "0",
  },
}));

const InternalChat = () => {
  const { chatId } = useParams();
  const classes = useStyles();
  const { user } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [chat, setChat] = useState(null);

  useEffect(() => {
    setLoading(true);
    const fetchChat = async () => {
      try {
        const { data } = await api.get(`/internal-chats/${chatId}`);
        setChat(data);
      } catch (err) {
        toastError(err);
      } finally {
        setLoading(false);
      }
    };
    if (chatId) fetchChat();
  }, [chatId]);

  useEffect(() => {
    const socket = connectToSocket();
    socket.on("connect", () => socket.emit("joinInternalChat", String(chatId)));
    socket.on("internalChat", (data) => {
      if (data.action === "update" && data.chat && data.chat.id === Number(chatId)) {
        setChat((prev) => (prev ? { ...prev, ...data.chat } : data.chat));
      }
    });
    return () => socket.disconnect();
  }, [chatId]);

  if (!chatId) return null;

  return (
    <div className={classes.root}>
      <Paper variant="outlined" elevation={0} className={classes.mainWrapper}>
        <InternalChatHeader loading={loading} chat={chat} user={user} />
        <InternalMessagesList chatId={chatId} />
        <InternalMessageInput chatId={chatId} />
      </Paper>
    </div>
  );
};

export default InternalChat;
